import { addSearchParamsToURL } from "@jugl-web/utils/utils/addSearchParamsToURL";
import { RtkBaseQuery } from "./types";

export function serializeSearchParams(obj: {
  [key: string]: string | number | undefined;
}) {
  if (!obj) {
    return "";
  }
  const str: string[] = [];
  const keys = Object.keys(obj);
  keys.forEach((key) => {
    const rawValue = obj[key];
    if (key && rawValue !== undefined && rawValue !== null && rawValue !== "") {
      const value = String(rawValue);
      str.push(
        `${encodeURIComponent(key).replace(/%2C/, ",")}=${encodeURIComponent(
          value
        ).replace(/%2C/, ",")}`
      );
    }
  });
  return str.join("&");
}

export const fetchAllPages = async <T>(
  url: string,
  params: { [key: string]: string | number },
  baseQuery: RtkBaseQuery
) => {
  let mergedItems: T[] = [];
  const resp = await baseQuery(addSearchParamsToURL(url, params || {}));
  if ("error" in resp) {
    // oxlint-disable-next-line no-throw-literal
    throw resp.error;
  }
  mergedItems = [...resp.data.data];
  const totalPages = resp.data.total_pages;
  let nextPage = 2;
  const extraQueries = [];

  while (nextPage <= totalPages) {
    extraQueries.push(
      addSearchParamsToURL(url, {
        ...(params || {}),
        page: nextPage,
      })
    );
    nextPage += 1;
  }
  const extraResponses = await Promise.all(
    extraQueries.map((query) => baseQuery(query))
  );
  extraResponses.forEach((extraResp) => {
    mergedItems = [...mergedItems, ...extraResp.data.data];
  });
  return mergedItems;
};
